import get from 'lodash/get';
import * as types from './constants';

const defaultState = {
  loading: false,
  error: null,
  loadingInModal: false,
  activeStep: 0,
  application: {},
  projectDetails: {},
  conditions: [],
  adminFeeScheduleDTOList: [],
  applicationInitalData: {},
  documents: [],
  applicationId: null,
  applicationType: '',
  contractDetails: {},
  breakdown: {},
  // escrow account
  accountTrustee: [],
  agreementDetail: {
    accountTrusteeMuncipality: '',
    accountTrustee: '',
    developerRegistrationMunicipality: '',
    developerAddress: '',
    developerAddressAr: '',
    trusteeNameAr: '',
    trusteeNameEn: '',
    trusteeAddressEn: '',
    trusteeAddressAr: '',
  },
  accountDetail: {
    escrowAccountNumber: '',
    escrowAccountIBAN: '',
    retentionAccountNumber: '',
    retentionIBANNumber: '',
  },
};

export default function escrowAccount(state = defaultState, action = {}) {
  switch (action.type) {
    case types.INITIATE_ESCROW_ACCOUNT_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.RESET_ESCROW_ACCOUNT_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case types.ESCROW_ACCOUNT_PAYMENT_BREAKDOWN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.ESCROW_ACCOUNT_PAYMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        application: { ...state.application, paymentBreakDown: get(action.payload, 'breakdown', {}) },
        breakdown: get(action.payload, 'breakdown', {}),
      };

    case types.ESCROW_ACCOUNT_PAYMENT_BREAKDOWN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.INITIATE_ESCROW_ACCOUNT_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        application: action.payload,
        applicationId: get(action.payload, 'applicationId', {}),
        conditions: get(action.payload, 'conditions', []),
        adminFeeScheduleDTOList: get(action.payload, 'adminFeeScheduleDTOList', []),
        projectDetails: get(action.payload, 'projectDetails', {}),
        applicationType: get(action.payload, 'applicationType', ''),
        agreementDetail: {
          accountTrusteeMuncipality: get(action.payload, 'projectDetails.trusteeMunicipalityId', ''),
          accountTrustee: get(action.payload, 'projectDetails.trusteeProfessionId', ''),
          developerRegistrationMunicipality: get(action.payload, 'projectDetails.developerRegisterMunicipalityId', ''),
          developerAddress: get(action.payload, 'projectDetails.developerAddress', ''),
          developerAddressAr: get(action.payload, 'projectDetails.developerAddressAr', ''),
          trusteeNameAr: get(action.payload, 'projectDetails.trusteeNameAr', ''),
          trusteeNameEn: get(action.payload, 'projectDetails.trusteeNameEn', ''),
          trusteeAddressEn: get(action.payload, 'projectDetails.trusteeAddressEn', ''),
          trusteeAddressAr: get(action.payload, 'projectDetails.trusteeAddressAr', ''),
        },
        accountDetail: {
          escrowAccountNumber: get(action.payload, 'projectDetails.escrowNumber', ''),
          escrowAccountIBAN: get(action.payload, 'projectDetails.escrowIban', ''),
          retentionAccountNumber: get(action.payload, 'projectDetails.retentionAccountNumber', ''),
          retentionIBANNumber: get(action.payload, 'projectDetails.retentionIBANNumber', ''),
        },
      };

    case types.ESCROW_ACCOUNT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.ESCROW_ACCOUNT_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ESCROW_ACCOUNT_LOADING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.ESCROW_ACCOUNT_LOADING_IN_MODAL:
      return {
        ...state,
        loading: false,
        loadingInModal: true,
        error: null,
      };

    case types.CLEAR_ESCROW_ACCOUNT_APPLICATION_ERROR:
      return {
        ...state,
        error: null,
      };

    case types.FETCH_APPLICATION_ESCROW_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        application: action.payload,
        applicationId: get(action.payload, 'applicationId', {}),
        applicationType: get(action.payload, 'applicationType', ''),
        conditions: get(action.payload, 'conditions', []),
        adminFeeScheduleDTOList: get(action.payload, 'adminFeeScheduleDTOList', []),
        projectDetails: get(action.payload, 'projectDetails', {}),
        agreementDetail: {
          accountTrusteeMuncipality: get(action.payload, 'projectDetails.trusteeMunicipalityId', ''),
          accountTrustee: get(action.payload, 'projectDetails.trusteeProfessionId', ''),
          developerRegistrationMunicipality: get(action.payload, 'projectDetails.developerRegisterMunicipalityId', ''),
          developerAddress: get(action.payload, 'projectDetails.developerAddress', ''),
          developerAddressAr: get(action.payload, 'projectDetails.developerAddressAr', ''),
          trusteeNameAr: get(action.payload, 'projectDetails.trusteeNameAr', ''),
          trusteeNameEn: get(action.payload, 'projectDetails.trusteeNameEn', ''),
          trusteeAddressEn: get(action.payload, 'projectDetails.trusteeAddressEn', ''),
          trusteeAddressAr: get(action.payload, 'projectDetails.trusteeAddressAr', ''),
        },
        accountDetail: {
          escrowAccountNumber: get(action.payload, 'projectDetails.escrowNumber', ''),
          escrowAccountIBAN: get(action.payload, 'projectDetails.escrowIban', ''),
          retentionAccountNumber: get(action.payload, 'projectDetails.retentionAccountNumber', ''),
          retentionIBANNumber: get(action.payload, 'projectDetails.retentionIBANNumber', ''),
        },
      };
    case types.FETCH_SPECIAL_CONDITION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        conditions: get(action.payload, 'conditions', []),
      };
    case types.ADD_ADMINSTRATION_FEES_SCHEDULE:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.ADD_ADMINSTRATION_FEES_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.ADD_ADMINSTRATION_FEES_SCHEDULE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.REMOVE_ADMINSTRATION_FEES_SCHEDULE:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.REMOVE_ADMINSTRATION_FEES_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.REMOVE_ADMINSTRATION_FEES_SCHEDULE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.EDIT_ADMINSTRATION_FEES_SCHEDULE:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.EDIT_ADMINSTRATION_FEES_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.EDIT_ADMINSTRATION_FEES_SCHEDULE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.UPDATE_ADMINSTRATION_FEES_SCHEDULE_DATA:
      return {
        ...state,
        adminFeeScheduleDTOList: action.payload,
      };

    case types.FETCH_ADMINSTRATION_FEES_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        adminFeeScheduleDTOList: get(action.payload, 'adminFeeScheduleDTOList', []),
      };
    case types.UPDATE_AGREEMENT_DETAILS_DATA:
      return {
        ...state,
        agreementDetail: {
          ...state.agreementDetail,
          ...action.payload,
        },
      };

    case types.UPDATE_ACCOUNT_DETAILS:
      return {
        ...state,
        accountDetail: {
          ...state.accountDetail,
          ...action.payload,
        },
      };

    case types.UPDATE_SPECIAL_CONDITION_DATA:
      return {
        ...state,
        conditions: action.payload,
      };

    // escrow account
    case types.SAVE_AGREEMENT_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.SAVE_AGREEMENT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.SAVE_AGREEMENT_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_ACCOUNT_TRUSTEE:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_ACCOUNT_TRUSTEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        accountTrustee: get(action.payload, 'accountTrustee', []),
      };

    case types.FETCH_ACCOUNT_TRUSTEE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.ADD_SPECIAL_CONDITION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.ADD_SPECIAL_CONDITION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.ADD_SPECIAL_CONDITION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.REMOVE_SPECIAL_CONDITION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.REMOVE_SPECIAL_CONDITION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.REMOVE_SPECIAL_CONDITION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.EDIT_SPECIAL_CONDITION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.EDIT_SPECIAL_CONDITION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.EDIT_SPECIAL_CONDITION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.DEVELOPER_APPROVAL:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.DEVELOPER_APPROVAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.DEVELOPER_APPROVAL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.BANK_CHECKER_APPROVAL:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.BANK_CHECKER_APPROVAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.BANK_CHECKER_APPROVAL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.BANK_SIGNATORY_APPROVAL:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.BANK_SIGNATORY_APPROVAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.BANK_SIGNATORY_APPROVAL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.DEVELOPER__SIGNATORY_APPROVAL:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.DEVELOPER__SIGNATORY_APPROVAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.DEVELOPER__SIGNATORY_APPROVAL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.REJECT_WITH_REASON:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.REJECT_WITH_REASON_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.REJECT_WITH_REASON_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Transfer Off Plan
    case types.FETCH_PROPERTY_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        property: get(action.payload, 'property', {}),
      };

    case types.FETCH_DOCUMENTS_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', []),
      };

    case types.INITIATE_TRANSFER_OFFPLAN_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.INITIATE_TRANSFER_OFFPLAN_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        brokers: get(action.payload, 'brokers', null),
        contractDetails: get(action.payload, 'contractDetails', {}),
        registrationFeeDetails: get(action.payload, 'registrationFeeDetails', {}),
      };

    case types.INITIATE_TRANSFER_OFFPLAN_APPLICATION_FAIL:
      return {
        ...state,
        loading: false,
      };
    case types.INITIATE_TRANSFER_OFFPLAN_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CHANGE_TRANSFER_OFFPLAN_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };
    case types.UPLOAD_TRANSFER_OFFPLAN_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_TRANSFER_OFFPLAN_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.UPLOAD_TRANSFER_OFFPLAN_DOCUMENT_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.ADD_TO_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SAVE_APPLICATION_TRANSFER_OFFPLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.SAVE_APPLICATION_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        // application: get(action.payload, 'application', {}),
        error: null,
      };

    case types.SAVE_APPLICATION_TRANSFER_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.TRANSFER_OFFPLAN_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.TRANSFER_OFFPLAN_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.TRANSFER_OFFPLAN_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SET_CONTRACT_DETAILS_TEST:
      return {
        ...state,
        contractDetails: { ...state.contractDetails, [action.payload.key]: action.payload.value },
      };
    case types.SET_REGESTRATION_FEES_PAID_BY:
      return {
        ...state,
        registrationFeeDetails: { ...state.registrationFeeDetails, [action.payload.key]: action.payload.value },
      };
    case types.CHECKOUT_TRANSFER_OFFPLAN_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.CHECKOUT_TRANSFER_OFFPLAN_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeStep: 0,
      };
    case types.CHECKOUT_TRANSFER_OFFPLAN_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.ENROLL_PROPERTY_IN_TAWTHEEQ:
      return {
        ...state,
        registrationFeeDetails: {
          ...state.registrationFeeDetails,
          enrollPropertyInTawteeq: !state.registrationFeeDetails.enrollPropertyInTawteeq,
        },
      };

    /** --------------- TRANSFER_OFFPLAN BANK MAKER --------------- */
    case types.SET_TRANSFER_OFFPLAN_BANK_MAKER_DETAILS:
      return {
        ...state,
        mortgageDetails: { ...state.mortgageDetails, [action.payload.key]: action.payload.value },
      };

    case types.FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION:
      return {
        ...state,
        loading: true,
        application: null,
      };
    case types.FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        documents: get(action.payload, 'documents', []),
        property: get(action.payload, 'property', {}),
        mortgageDetails: get(action.payload, 'mortgageDetails', {}),
        mortgageTypes: get(action.payload, 'mortgageTypes', []),
        bankSignatories: get(action.payload, 'bankSignatories', []),
        valuationCompanies: get(action.payload, 'valuationCompanies', []),
        contractDetails: get(action.payload, 'contractDetails', {}),
      };
    case types.FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_TRANSFER_OFFPLAN_VALUATORS:
      return {
        ...state,
        loading: true,
        error: null,
        valuators: [],
      };
    case types.FETCH_TRANSFER_OFFPLAN_VALUATORS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        valuators: get(action.payload, 'valuators', []),
      };
    case types.FETCH_TRANSFER_OFFPLAN_VALUATORS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        valuators: [],
      };

    case types.CLEAR_TRANSFER_OFFPLAN_VALUATORS:
      return {
        ...state,
        valuators: [],
        mortgageDetails: { ...state.mortgageDetails, valuatorProfessionId: null },
      };

    case types.SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        documents: get(action.payload, 'documents', {}),
        property: get(action.payload, 'property', {}),
        activeStep: get(action.payload, 'step'),
        error: null,
      };

    case types.SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // post flow
    case types.APPROVAL_TRANSFER_OFFPLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.APPROVAL_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.APPROVAL_TRANSFER_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.POST_RETURN_TRANSFER_OFFPLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.POST_RETURN_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.POST_RETURN_TRANSFER_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        breakdown: get(action.payload, 'breakdown', {}),
      };
    case types.TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.TRANSFER_OFFPLAN_CLEAR_DATA:
      return {
        ...defaultState,
      };
    case types.DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
